import PlatformExpertsComponent from './PlatformExperts.component'

export default PlatformExpertsComponent